import {Route} from '@/router/route';
import AvailabilityOverview from '@/views/AvailabilityOverview.vue';
import DetailsOverview from '@/views/DetailsOverview.vue';
import {createRouter, createWebHashHistory} from 'vue-router';

const router = createRouter({
	history: createWebHashHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: '/',
			redirect: {
				name: Route.AVAILABILITY_OVERVIEW
			},
			children: [
				{
					path: 'availability',
					name: Route.AVAILABILITY_OVERVIEW,
					component: AvailabilityOverview
				},
				{
					path: 'details',
					name: Route.DETAILS_OVERVIEW,
					component: DetailsOverview
				}
			]
		}
	]
});

export default router;
